import React from 'react';
import { List } from 'antd';

import EventItem from '../../Items/EventItem';
import './EventList.less';

const EventList = ({
  userClaims, 
  events, 
  pageType, 
  handleDeleteEvent, 
  handleLike, 
  pathFrom,
  savingEvent_id,
  updateSaveEventId,
  user 
}) => (
  <List
    className="list-vertical list-mobile-small"
    grid={{
      gutter: 32,
      xs: 1,
      sm: 2,
      md: 3,
    }}
    dataSource={events}
    renderItem={(item) => (
      <EventItem
        item={item}
        pageType={pageType}
        handleDeleteEvent={() => handleDeleteEvent(item)}
        handleLike={() => handleLike(item)}
        claims={userClaims}
        pathFrom={pathFrom}
        savingEvent_id={savingEvent_id}
        updateSaveEventId={updateSaveEventId}
      />
    )}
  />
);

export default EventList;


// WEBPACK FOOTER //
// ./src/components/Modules/EventList/index.js